import { render, staticRenderFns } from "./PSDEditorView.vue?vue&type=template&id=298a6b83"
import script from "./PSDEditorView.vue?vue&type=script&lang=js"
export * from "./PSDEditorView.vue?vue&type=script&lang=js"
import style0 from "./PSDEditorView.vue?vue&type=style&index=0&id=298a6b83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports